import { useAppRouter } from '@/common/route/useAppRouter';
import { StringUtils } from '@/common/utils/stringUtils';
import { useCrudActions } from '@/common/view/useCrudActions';
import { ROUTE_NAME_COLLECTION } from '@/modules/collection/router';
import { collectionService } from '@/services/collection';
import { reactive } from 'vue';
import { useRoute } from 'vue-router';

export function useCollectionDetail() {
    const route = useRoute();
    const router = useAppRouter();
    const { executeAction, confirmAndRemove, confirmAndExecute } = useCrudActions();

    const model = reactive({
        collectionId: StringUtils.toNumber(route.params.collectionId),
        type: StringUtils.toNumber(route.query.type),
        name: '',
        coverColor: null,
        status: null,
        image: null,
        imageStatus: null,
        canPublish: false,
        canUnpublish: false,
        canDelete: false
    });

    const fetch = executeAction({
        request: () => collectionService.get(model.collectionId),
        onSuccess: ({ data }) => Object.assign(model, data),
        onError: () => router.push({ name: ROUTE_NAME_COLLECTION.INDEX(model.type) })
    });

    const actions = {
        remove: confirmAndRemove({
            request: () => collectionService.remove(model.collectionId),
            onSuccess: () => router.push({ name: ROUTE_NAME_COLLECTION.INDEX(model.type) })
        }),
        publish: confirmAndExecute({
            confirmMessage: 'Are you sure you want to publish this item?',
            request: () => collectionService.publish(model.collectionId),
            onSuccess: () => fetch()
        }),
        unpublish: confirmAndExecute({
            confirmMessage: 'Are you sure you want to unpublish this item?',
            request: () => collectionService.unpublish(model.collectionId),
            onSuccess: () => fetch()
        })
    };

    return { model, fetch, actions };
}
